// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3slrS","right":"Footer_right__3A9yG","buttons":"Footer_buttons__RPAoQ"};